import { render, staticRenderFns } from "./sub-slide-primary.vue?vue&type=template&id=3faf0174&scoped=true&"
import script from "./sub-slide-primary.vue?vue&type=script&lang=js&"
export * from "./sub-slide-primary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3faf0174",
  null
  
)

export default component.exports